var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-setting-view" },
    [
      _vm._m(0),
      _c("el-divider"),
      _c(
        "el-form",
        {
          ref: "submitSettingForm",
          attrs: { model: _vm.submitSettingForm, rules: _vm.settingRules },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c("p", { staticClass: "label", staticStyle: { width: "30%" } }, [
                _vm._v("提交后显示方式"),
              ]),
              _c(
                "el-radio-group",
                {
                  directives: [
                    { name: "removeAriaHidden", rawName: "v-removeAriaHidden" },
                  ],
                  on: { change: _vm.submitShowTypeChange },
                  model: {
                    value: _vm.submitSettingForm.submitShowType,
                    callback: function ($$v) {
                      _vm.$set(_vm.submitSettingForm, "submitShowType", $$v)
                    },
                    expression: "submitSettingForm.submitShowType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(" 系统默认提示 "),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(" 自定义文案 "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c("el-input", {
                attrs: { disabled: _vm.submitSettingForm.submitShowType === 1 },
                model: {
                  value: _vm.submitSettingForm.submitShowCustomPageContent,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.submitSettingForm,
                      "submitShowCustomPageContent",
                      $$v
                    )
                  },
                  expression: "submitSettingForm.submitShowCustomPageContent",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c(
                "p",
                { staticClass: "label" },
                [
                  _vm._v(" 提交后跳转地址 "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "top-start" },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            " 此属性用于指定答题完成后跳转的地址，可参考以下格式 "
                          ),
                          _c("br"),
                          _vm._v(" 1.网页地址，需填写完整url"),
                          _c("br"),
                          _vm._v("示例：https://demo.com"),
                          _c("br"),
                          _vm._v(" 2.小程序页面地址"),
                          _c("br"),
                          _vm._v(
                            "示例：/member/pages/activity/couponActivity?id=123456789 "
                          ),
                        ]
                      ),
                      _c("i", { staticClass: "el-icon-question" }),
                    ]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                model: {
                  value: _vm.submitSettingForm.submitJump,
                  callback: function ($$v) {
                    _vm.$set(_vm.submitSettingForm, "submitJump", $$v)
                  },
                  expression: "submitSettingForm.submitJump",
                },
              }),
            ],
            1
          ),
          _vm.submitSettingForm.submitJump
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "submitJumpUrl",
                    rules: [
                      {
                        required: true,
                        message: "请输入跳转地址",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.submitSettingForm.submitJumpUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.submitSettingForm, "submitJumpUrl", $$v)
                      },
                      expression: "submitSettingForm.submitJumpUrl",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "setting-item" },
            [
              _c(
                "p",
                { staticClass: "label" },
                [
                  _vm._v(" 提交问卷奖励 "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "top-start" },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            " 用于关联会员营销活动，配置用户提交该问卷时发放的活动奖励，具体活动设置见iadmin营销模块 "
                          ),
                        ]
                      ),
                      _c("i", { staticClass: "el-icon-question" }),
                    ]
                  ),
                ],
                1
              ),
              _c("el-switch", {
                model: {
                  value: _vm.submitSettingForm.memberMarketingActivities.enable,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.submitSettingForm.memberMarketingActivities,
                      "enable",
                      $$v
                    )
                  },
                  expression:
                    "submitSettingForm.memberMarketingActivities.enable",
                },
              }),
            ],
            1
          ),
          _vm.submitSettingForm.memberMarketingActivities.enable
            ? _c(
                "div",
                { staticClass: "flex-row align-center el_activity" },
                [
                  _vm._v(" 提交触发会员营销活动 "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "memberMarketingActivities.brandCode",
                        rules: [
                          {
                            required: true,
                            message: "请选择品牌",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "item-config-col1",
                          staticStyle: { margin: "0 6px", width: "140px" },
                          model: {
                            value:
                              _vm.submitSettingForm.memberMarketingActivities
                                .brandCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.submitSettingForm.memberMarketingActivities,
                                "brandCode",
                                $$v
                              )
                            },
                            expression:
                              "submitSettingForm.memberMarketingActivities.brandCode",
                          },
                        },
                        _vm._l(_vm.brandList, function (brand) {
                          return _c("el-option", {
                            key: brand.code,
                            attrs: { label: brand.name, value: brand.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticClass: "item-config-col1",
                      staticStyle: { margin: "0 6px", width: "140px" },
                      model: {
                        value:
                          _vm.submitSettingForm.memberMarketingActivities.type,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.submitSettingForm.memberMarketingActivities,
                            "type",
                            $$v
                          )
                        },
                        expression:
                          "submitSettingForm.memberMarketingActivities.type",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "点击领取活动",
                          value: "CLICK_TO_RECEIVE_EVENT",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "memberMarketingActivities.activityId",
                        rules: [
                          {
                            required: true,
                            message: "请输入活动id",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入活动id" },
                        on: {
                          input: function ($event) {
                            return _vm.changeInput($event)
                          },
                        },
                        model: {
                          value:
                            _vm.submitSettingForm.memberMarketingActivities
                              .activityId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.submitSettingForm.memberMarketingActivities,
                              "activityId",
                              $$v
                            )
                          },
                          expression:
                            "submitSettingForm.memberMarketingActivities.activityId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "submit-btn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveSettingHandle },
                },
                [_vm._v(" 保存设置 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "project-setting-title" }, [
      _vm._v(" 提交设置 "),
      _c("span", { staticClass: "small-font-size ml20 text-secondary-color" }, [
        _vm._v(" 自定义表单提交成功后的提示内容，以及可以跳转指定链接 "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }